import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalCacheService } from '../local-cache/local-cache.service';
@Injectable()
export class RequestHeadersInterceptor implements HttpInterceptor {
  constructor(public cache: LocalCacheService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.body instanceof FormData) {
      return next.handle(request);
    }
    request = request.clone({
      setHeaders: {
        'Content-Type':  'application/json'
      }
    });
    return next.handle(request);
  }
}

